import React from 'react';
import styled from '@emotion/styled';
import { Box, Flex } from '@qga/roo-ui/components';
import PropTypes from 'prop-types';
import { themeGet } from 'styled-system';

import Heading from '@/components/Heading';
import Text from '@/components/Text';
import withProps from '@/components/withProps';
import PackageOffer from '@/propTypes/PackageOffer';
import { formatMoneyWithoutDollar } from '@/utils/formatMoney';

const Dot = styled(Box)`
  width: 12px;
  height: 12px;
  position: absolute;
  left: calc(12px / -2);
  top: calc(12px * -1);
  border: 2px solid ${themeGet('colors.white')};
  border-radius: 100%;
`;

const PriceLabel = withProps({
  bg: 'white',
  borderRadius: 'default',
  boxShadow: 'soft',
  p: '1',
})(styled(Box)`
  z-index: 1;
  position: absolute;
  bottom: calc(12px + 10px);
  transform: translateX(-50%);

  &::after {
    content: '';
    display: block;
    width: 8px;
    height: 8px;
    background: ${themeGet('colors.white')};
    position: absolute;
    left: calc(50% - 4px);
    transform: rotate(45deg);
  }
`);

const Caret = styled(Box)`
  position: relative;
  display: inline;
  font-size: 12px;
  bottom: 3px;
  margin: 0 1px;
`;

const Price = ({ isSelected = false, packageOffer }) => (
  <>
    <Dot data-testid="DOT" bg={isSelected ? 'secondary' : 'primary'} />
    {packageOffer && (
      <PriceLabel data-testid="PRICE_LABEL" isSelected={isSelected}>
        <Flex>
          <Heading.h6>
            <Caret>$</Caret>
            {formatMoneyWithoutDollar(
              packageOffer.charges.perTraveller.amount,
              { wholeDollars: true },
            )}
            <Caret>^</Caret>
          </Heading.h6>
          <Text textStyle="small">&nbsp;pp</Text>
        </Flex>
      </PriceLabel>
    )}
  </>
);

Price.propTypes = {
  isSelected: PropTypes.bool,
  packageOffer: PropTypes.shape(PackageOffer),
};

export default Price;
